module.exports = __webpack_public_path__ + "img/avatar.aa0abf3e.png";